import moment from 'moment'
import { cloneDeep } from 'lodash'
const DateUtils = {
  getMonthArr: function(startMonthStr, length) {
    const startDate = moment(startMonthStr)
    const res = []
    if (length > 0) {
      res.push(cloneDeep(startDate))
      for (let i = 1; i < length; i++) {
        res.push(cloneDeep(startDate.add(1, 'months')))
      }
    } else if (length < 0) {
      res.push(cloneDeep(startDate))
      for (let i = length + 1; i < 0; i++) {
        res.push(cloneDeep(startDate.subtract(1, 'months')))
      }
    }
    return res
  }
}
export default DateUtils
